import Typography from 'components/Typography/Typography'
import ErrorWindow from 'components/Windows/ErrorWindow/ErrorWindow'
import { Container } from 'react-bootstrap'
import { useIntl } from 'react-intl'

export default function ErrorFallback() {
    const intl = useIntl()
    let referer = localStorage.getItem('referer')
    if (!referer || referer === 'undefined') {
        referer = `https://${process.env.REACT_APP_WEB_PORTAL_URL}`
    }

    return (
        <div className="d-flex p-5">
            <Container
                fluid
                className="page-404 h-100 d-flex flex-column justify-content-center align-items-center px-3"
            >
                <Typography variant={'h1'} className={'me-auto'}>
                    {intl.formatMessage({ id: 'appError.pageTitle' })}
                </Typography>
                <ErrorWindow
                    title={intl.formatMessage({ id: 'appError.title' })}
                    description={intl.formatMessage({ id: 'appError.description' })}
                    textButton1={intl.formatMessage({ id: 'appError.button' })}
                    onClickButton1={() => (window.location.href = referer)}
                />
            </Container>
        </div>
    )
}
